import { Injectable } from '@angular/core';
import { UIService } from '../shared/ui.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/index';
import { environment } from '../../environments/environment';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  currentProject: number;

  constructor(
    private http: HttpClient,
    private uiService: UIService,
    private storageService: StorageService,

  ) { }


  getOrdersCountByType(token): Observable<Response> {
    this.uiService.loadingStateChanged.next(true);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);

    this.currentProject = this.storageService.getPreferredProject();

    const body = {};
    if (this.currentProject !== null){
      body['project'] = this.currentProject.toString();
    }

    const url = environment.APIEndpoint + 'client-api/reservations/counts/';
    return this.http.get<Response>(url, {
      headers: headers,
      params: body
    });
  }
}
